'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import Small from 'UIComponents/elements/Small';
import Networks from 'ads-account-connection/lib/Networks';
import UISelectableBox from 'UIComponents/button/UISelectableBox';
import NetworkIcon from 'ads-account-connection/components/NetworkIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UILink from 'UIComponents/link/UILink';
import { FB_CONVERSION_API_LEARN_MORE_LINK } from 'ads-account-connection/lib/Constants';
import PortalIdParser from 'PortalIdParser';
import { Fragment } from 'react';
const ADS_ACCOUNT_SETTINGS_PATH = `/settings/${PortalIdParser.get()}/marketing/ads/adAccounts`;

const NetworkSelectBox = ({
  disabled,
  network,
  onClick,
  isProOrEnterprise
}) => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(UISelectableBox, {
      disabled: disabled,
      selected: false,
      block: true,
      width: 380,
      onClick: onClick,
      className: `select-${network.toLowerCase()}-button text-left`,
      children: [/*#__PURE__*/_jsx(UIMediaObject, {
        itemLeft: /*#__PURE__*/_jsx(NetworkIcon, {
          network: network
        }),
        children: /*#__PURE__*/_jsx(UIFlex, {
          direction: "row",
          justify: "between",
          align: "center",
          children: /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `ADS_ACCOUNT_CONNECTION.networks.${network.toLowerCase()}`
            })
          })
        })
      }), !disabled && network === Networks.FACEBOOK && isProOrEnterprise && /*#__PURE__*/_jsxs(Small, {
        use: "help",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "ADS_ACCOUNT_CONNECTION.conversionsApi.description"
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UILink, {
          external: true,
          href: FB_CONVERSION_API_LEARN_MORE_LINK,
          onClick: e => e.stopPropagation(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.conversionsApi.learnMore"
          })
        })]
      })]
    }), disabled && /*#__PURE__*/_jsx(UIFlex, {
      direction: "column",
      align: "start",
      className: "m-top-1",
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "ADS_ACCOUNT_CONNECTION.conversionsApi.networkNotConnectedError_jsx",
          options: {
            href: ADS_ACCOUNT_SETTINGS_PATH
          },
          elements: {
            Link: UILink
          }
        })
      })
    })]
  });
};

NetworkSelectBox.propTypes = {
  disabled: PropTypes.bool,
  network: PropTypes.oneOf(Object.keys(Networks)).isRequired,
  onClick: PropTypes.func.isRequired,
  isProOrEnterprise: PropTypes.bool.isRequired
};
export default NetworkSelectBox;